import React, { memo } from 'react';
import PropTypes from 'prop-types';

import ContentSection from 'components/ContentSection';
import ContentSectionTitle from 'components/ContentSectionTitle';

import { LinksList, LinksListItem, Link } from './styles';

const SeoLinksBlock = memo(({ title, links }) => {
  const safeLinks = Array.isArray(links)
    ? links.filter(link => link && typeof link === 'object')
    : [];

  if (safeLinks.length === 0) {
    return null;
  }

  return (
    <ContentSection>
      <ContentSectionTitle>{title}</ContentSectionTitle>

      <LinksList>
        {safeLinks.map(link => (
          <LinksListItem key={link.id}>
            <Link href={link.url} title={link.name}>
              {link.name}
            </Link>
          </LinksListItem>
        ))}
      </LinksList>
    </ContentSection>
  );
});

SeoLinksBlock.propTypes = {
  title: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(PropTypes.object),
};

SeoLinksBlock.defaultProps = {
  links: [],
};

export default SeoLinksBlock;
